import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// TASK-131 F3: Bootstrap purgado (generado con tools/purge-bootstrap.js); baja ~10 KiB gz del CSS bloqueante
import './styles/bootstrap.purged.css';
import './styles/global.css'; // Estilos globales (ej: ocultar reCAPTCHA)
// TASK-121: estilos de AppModal cargados una sola vez y en orden fijo. Importarlos desde el
// componente hacía que cada página los ordenara distinto respecto de su CSS ("Conflicting order").
import './styles/AppModal.css';
import './components/layout/PageHeader.css';
import './components/notifications/NotificationBell.css';
import { installIosViewportFix } from './utils/iosViewportFix';

// TASK-153: el HTML servido trae tags SEO por defecto (o los de la ruta, en las páginas
// prerenderizadas) marcados con data-seo-static. Cada página pone los suyos con SEOMeta, así que se
// quitan antes de montar: si no, quedaban dos canonical (el primero siempre apuntando a la home).
document.querySelectorAll('[data-seo-static]').forEach((el) => el.remove());

// TASK-156: en iPhone (app instalada) la barra inferior y los modales quedaban corridos al cerrar el teclado
installIosViewportFix();

// El código que renderiza el componente principal en el DOM
const root = ReactDOM.createRoot(document.getElementById('root'));  // Verifica que 'root' sea el ID correcto en tu HTML
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Si deseas medir el rendimiento de tu aplicación, puedes pasar una función a reportWebVitals
//reportWebVitals();

// 🚀 Registro de Service Worker y Almacenamiento Persistente para PWA Nativa
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // Solicitar almacenamiento persistente al sistema operativo
        if (navigator.storage && navigator.storage.persist) {
          navigator.storage.persist().then(isPersisted => {
            // Guardado persistente garantizado por el sistema operativo
          });
        }
      })
      .catch(() => { /* Error silencioso en producción */ });
  });
}

